// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Foreign from "../Foreign/index.js";
var isObject = function (v) {
    return Foreign.tagOf(v) === "Object";
};
var readObject = function (value) {
    if (isObject(value)) {
        return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Foreign.unsafeFromForeign(value));
    };
    if (Data_Boolean.otherwise) {
        return Foreign.fail(Data_Identity.monadIdentity)(new Foreign.TypeMismatch("Object", Foreign.tagOf(value)));
    };
    throw new Error("Failed pattern match at Foreign.Generic.Internal (line 13, column 1 - line 13, column 44): " + [ value.constructor.name ]);
};
export {
    isObject,
    readObject
};
//# sourceMappingURL=index.js.map
